import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import "../../../assets/css/slick-theme.css";
import Slider from "react-slick";
import React, { useState } from "react";
import { Box, styled } from "@mui/material";
import slider1 from "../../../assets/images/slider1.png";
import slider2 from "../../../assets/images/slider2.png";
import slider3 from "../../../assets/images/slider3.png";
import { isMobile } from "../../../utils/helper";

export function SlideProgressActive() {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    appendDots: (dots: any) => {
      return <ul>{dots}</ul>;
    },
    beforeChange: (prev: number, next: number) => {
      setCurrentSlideIndex(next);
    },
    customPaging: (pagi: number) => {
      const style = {
        width: "20px",
        height: "2px",
        background: "#00588B",
        opacity: "0.2",
      };
      const activeStyle = {
        width: "20px",
        height: "2px",
        background: "#00588B",
      };
      return (
        <div
          className="slick-dot"
          style={pagi === currentSlideIndex ? activeStyle : style}
        ></div>
      );
    },
  };
  return (
    <Box id="slider" sx={{ marginTop: "20px" }}>
      <Slider {...settings}>
        <ItemSlider
          imageSrc={slider1}
          title={"Gửi thông tin sản phẩm nhanh chóng đến khách hàng"}
          content={
            "Khách hàng sẽ nhận được link sản phẩm của cửa hàng qua nhiều nền tảng: Facebook, Zalo, Tiktok"
          }
        />
        <ItemSlider
          imageSrc={slider2}
          title={"Đặt hàng từ xa, gọi món qua QR code dễ dàng"}
          content={
            "Khách hàng có thể đặt hàng từ xa, gọi món tại quán cửa hàng trực tuyến của bạn thông qua đường dẫn hoặc mã QR"
          }
        />
        <ItemSlider
          imageSrc={slider3}
          title={"Quản lý sản phẩm, đơn hàng tại KiotViet"}
          content={
            "Tự động đồng bộ dữ liệu từ KiotViet lên website bán hàng và quản lý đơn hàng hiệu quả."
          }
        />
      </Slider>
    </Box>
  );
}
const DomSliderMobile = styled("div")({
  padding: "20px 20px 40px 20px",
  textAlign: "center",
  background: "linear-gradient(176.19deg, #F9FDFF 3.29%, #EAF7FF 99.56%)",
  borderRadius: "12px",
  marginBottom: "12px",
  height: "416px",
  "> div:nth-of-type(1)": {
    display: "flex",
    justifyContent: "center",
  },
  "> div:nth-of-type(2)": {
    fontSize: "20px",
    lineHeight: "140%",
    fontWeight: "700",
    color: "#002246",
  },
  "> div:nth-of-type(3)": {
    color: "#323741",
    fontSize: "14px",
    lineHeight: "20px",
  },
});

const DomSlider = styled("div")({
  padding: "30px",
  display: "flex",
  alignItems: "center",
  width: "600px",
  background: "linear-gradient(176.19deg, #F9FDFF 3.29%, #EAF7FF 99.56%)",
  borderRadius: "12px",
  marginBottom: "12px",
  gap: "38px",
  "> div:nth-of-type(1)": {
    "> div:nth-of-type(1)": {
      color: "#002246",
      fontSize: "20px",
      fontWeight: "700",
      lineHeight: "140%",
    },
    "> div:nth-of-type(2)": {
      color: "#323741",
      marginTop: "8px",
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
});
export function ItemSlider({
  imageSrc,
  title,
  content,
}: {
  imageSrc: any;
  title: string;
  content: string;
}) {
  return (
    <>
      {isMobile() ? (
        <DomSliderMobile>
          <Box>
            <img src={imageSrc} width={240} height={240} />
          </Box>
          <Box sx={{}}>{title}</Box>
          <Box>{content}</Box>
        </DomSliderMobile>
      ) : (
        <DomSlider>
          <Box>
            <Box>{title}</Box>
            <Box>{content}</Box>
          </Box>
          <Box>
            <img src={imageSrc} width={276} height={276} />
          </Box>
        </DomSlider>
      )}
    </>
  );
}
